<template>
  <el-dialog :visible.sync="dialogVisible" title="媒体计划ID" width="340px" :show-close="false" :close-on-click-modal="false">
    <div class="ghost-button-styles">
      <ElForm>
        <ElFormItem>
          <el-radio-group v-model="landData.type">
            <!-- 苹果ASA独有 -->
            <el-radio-button v-if="landData.mediaId === 193" ghost :label="2">关键词ID</el-radio-button>
            <!-- 视频号任务独有 -->
            <el-radio-button v-else-if="landData.mediaId === 225" ghost :label="4">视频号ID</el-radio-button>

            <template v-else>
              <el-radio-button ghost :label="0">媒体计划ID</el-radio-button>
              <el-radio-button ghost :label="1">计划主ID</el-radio-button>
              <el-radio-button ghost :label="3">场景值ID</el-radio-button>
            </template>
          </el-radio-group>
        </ElFormItem>
        <ElFormItem>
          <el-input v-model.trim="landData.mediaPlanId" placeholder="请输入" style="width: 282px" />
        </ElFormItem>
      </ElForm>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deepCopy } from '@/common/js/utils'
import { setMediaPlanId } from '@/api/track.plan.model'

const defaultLandData = {
  planId: 0,
  type: 0,
  mediaId: '',
  mediaPlanId: ''
}

export default {
  name: 'MediaPlanId',
  props: {
    value: {
      type: Boolean
    },
    info: {
      type: Object
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    info: {
      handler() {
        this.$nextTick(() => {
          this.updateInfo()
        })
      },
      deep: true
    }
  },
  methods: {
    save() {
      const { mediaId, type, mediaPlanId, planId } = this.landData
      var reg = /^[0-9]*$/
      if (!reg.test(mediaPlanId) && [0, 1, 2, 3].includes(type)) {
        this.$Message.warning('只能输入数字！')
        return
      }
      if (type === 0) {
        if (mediaPlanId.length > 50) {
          this.$Message.warning('媒体计划Id超过最大长度50字符限制！')
          return
        }
      } else if (type === 1) {
        if (mediaPlanId.length > 37) {
          this.$Message.warning('计划主Id超过最大长度37字符限制')
          return
        }
      } else if (type === 2) {
        if (mediaPlanId.length > 41) {
          this.$Message.warning('关键词Id超过最大长度41字符限制')
          return
        }
      } else if (type === 3) {
        if (mediaPlanId.length > 41) {
          this.$Message.warning('关键词Id超过最大长度41字符限制')
          return
        }
      } else if (type === 4) {
        if (mediaPlanId.length > 41) {
          this.$Message.warning('视频号Id超过最大长度41字符限制')
          return
        }
      }
      this.loading = true
      setMediaPlanId({
        planId,
        mediaId,
        mediaPlanId: this.getMediaPlanId(type, mediaPlanId)
      }).then((data) => {
        this.loading = false
        if (data && this.value) {
          this.$Message.success('保存成功')
          this.closeModal()
          this.$emit('on-refresh')
        }
      })
    },
    closeModal() {
      this.landData = deepCopy(defaultLandData)
      this.$nextTick(() => {
        this.updateInfo()
      })
      this.dialogVisible = false
    },
    updateInfo() {
      const info = JSON.parse(JSON.stringify(this.info))
      this.landData = info && Object.keys(info).length !== 0 ? info : deepCopy(defaultLandData)
      const mediaPlanId = this.landData.mediaPlanId
      if (mediaPlanId && mediaPlanId.indexOf('advertiser_id') === 0) {
        this.$set(this.landData, 'type', 1)
        this.$set(this.landData, 'mediaPlanId', mediaPlanId.substr(13))
      } else if (mediaPlanId && mediaPlanId.indexOf('keywordId') === 0) {
        this.$set(this.landData, 'type', 2)
        this.$set(this.landData, 'mediaPlanId', mediaPlanId.substr(9))
      } else if (mediaPlanId && mediaPlanId.indexOf('scene_id') === 0) {
        this.$set(this.landData, 'type', 3)
        this.$set(this.landData, 'mediaPlanId', mediaPlanId.substr(8))
      }
    },
    getMediaPlanId(type, mediaPlanId) {
      switch (type) {
        case 1:
          return `advertiser_id${mediaPlanId}`
        case 2:
          return `keywordId${mediaPlanId}`
        case 3:
          return `scene_id${mediaPlanId}`
        case 4:
          return mediaPlanId
        default:
          return mediaPlanId
      }
    }
  },
  data() {
    return {
      landData: deepCopy(defaultLandData),
      loading: false
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped></style>
